module.exports = __webpack_public_path__ + "static/iosCheckTechInspection-bbb8dcbd63d7df885587f60dcfeedca9.jpg";